import { render, staticRenderFns } from "./DutyCardList.vue?vue&type=template&id=35ff4960&scoped=true"
import script from "./DutyCardList.vue?vue&type=script&lang=js"
export * from "./DutyCardList.vue?vue&type=script&lang=js"
import style0 from "./DutyCardList.vue?vue&type=style&index=0&id=35ff4960&prod&lang=scss"
import style1 from "./DutyCardList.vue?vue&type=style&index=1&id=35ff4960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff4960",
  null
  
)

export default component.exports